import styled from '@emotion/styled';

import { COLORS, FONT, ZINDEX, MEDIA_QUERY, SPACING } from '../../../styles/emotion';

export const StyledFooter = styled.footer`
  align-items: center;
  background-color: ${COLORS.PURPLE};
  display: flex;
  flex-flow: row;
  height: 331px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const ImgContainer = styled.div`
  bottom: 0;
  display: none;
  left: -50px;
  ${MEDIA_QUERY.DESKTOP_LG} {
    left: 0;
  }
  object-fit: contain;
  position: absolute;
  top: 0;

  img {
    clip-path: ellipse(100% 75% at 0% 50%);
  }

  ${MEDIA_QUERY.TABLET} {
    display: block;
  }
  ${MEDIA_QUERY.DESKTOP} {
    display: block;
  }
`;

export const TxtContainer = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column;
  justify-content: center;
  position: relative;
  z-index: ${ZINDEX.top};
`;

export const FooterHeader = styled.h2`
  color: ${COLORS.WHITE};
  font-family: ${FONT.FONT_FAMILY_POYNTER};
  font-size: 64px;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  letter-spacing: -0.666667px;
  line-height: 90px;
  margin: 0 0 ${SPACING.MD} 0;
  text-align: center;
  max-width: 100%;

  ${MEDIA_QUERY.MOBILE_XS} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGER)}
    letter-spacing: 0.18px;
    margin: 0 0 21px 0;
  }

  ${MEDIA_QUERY.MOBILE} {
    font-size: 26px;
    letter-spacing: 0.18px;
    line-height: 29px;
    margin: 0 0 21px 0;
  }

  ${MEDIA_QUERY.TABLET} {
    font-size: 48px;
    letter-spacing: 0.5px;
    line-height: 53px;
    margin: 0 0 16px 0;
    max-width: 300px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    margin: 0 0 ${SPACING.S32} 0;
    max-width: 375px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    max-width: 100%;
  }
`;

export const Br = styled.br`
  ${MEDIA_QUERY.DESKTOP_LG} {
    display: none;
  }
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
`;
